import { useTranslation } from 'react-i18next';
import Icon from '../../ui/icon';

type CommentsThinkWarningProps = {
  thinkWarningHtml?: string;
  thinkWarningLink?: string;
};

export function CommentsThinkWarning({
  thinkWarningHtml,
  thinkWarningLink,
}: CommentsThinkWarningProps) {
  const { t } = useTranslation();
  const defaultWarningHtml = `<strong>${t(
    'comments.warning.think_before'
  )} </strong><span style="opacity:0.7">${t(
    'comments.warning.before_send'
  )} </span>`;

  thinkWarningHtml = thinkWarningHtml || defaultWarningHtml;
  const linkHtml = thinkWarningLink
    ? `<a class="think-warning__link" target="_blank" rel="noopener noreferrer" href="${thinkWarningLink}">${t(
        'comments.warning.more_info'
      )}</a>`
    : '';

  const thinkWarningBodyHtml = {
    __html: `${thinkWarningHtml}${linkHtml}`,
  };

  return (
    <div className="comments__think-warning">
      <div className="think-warning__lightbulb-wrapper">
        <Icon type="emoji_objects" />
      </div>
      <div
        className="think-warning__body"
        dangerouslySetInnerHTML={thinkWarningBodyHtml}
      />
    </div>
  );
}
